"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.success.title': '¡Cuenta activada!',
    'activate.success.description': 'Tu cuenta ha sido activada exitosamente. Ahora puedes iniciar sesión y comenzar a usar IntHub.',
    'activate.success.message': '¡Cuenta activada exitosamente!',
};
